module.exports = __webpack_public_path__ + "static/img/v4-bottom-d-right.3ef69cb5.png";